import { IApplicationContext } from '../../../shared/common/types/applicationContext';
import { IApplicationState, TReduxStore } from '../../../shared/common/types/redux';
import { createReduxStore } from '../../../shared/common/utils/redux';

export function createApplicationState(context: IApplicationContext): TReduxStore {
  const { config } = context;

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(context, initialState, true);
}
